<script setup lang="ts">
import { computed, toRefs } from 'vue';

import MapCoordinateItem from '#nora-ui/map/components/controls/map-info/MapCoordinateItem.vue';
import { useMapCoordinates } from '#nora-ui/map/composables/useMapCoordinates';
import { useMapStore } from '#nora-ui/map/stores/map-store';

interface MapCoordinatesProps {
  mapId: string;
}

const props = defineProps<MapCoordinatesProps>();
const { mapId } = toRefs(props);

const mapStore = useMapStore();

const map = mapStore.getMapByIdOrThrow(mapId.value);

const { centerCoordinates } = useMapCoordinates({ map });

const sortedCoordinateFormats = computed(() => {
  return map.ref.visibleCoordinateFormats.slice().sort((a, b) => {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0; // names must be equal
  });
});
</script>

<template>
  <div
    v-if="map.ref.hasVisibleCoordinateSystems()"
    class="flex flex-col items-end gap-1 font-mono text-sm pointer-events-auto"
  >
    <MapCoordinateItem
      v-for="format in sortedCoordinateFormats"
      :key="format"
      :coordinate-format="format"
      :center-coordinates="centerCoordinates"
      :map="map"
    />
  </div>
</template>
